import { z } from "zod";
import { adminSafeIdentifierSchema, adminSha256Schema, adminUlidSchema, } from "./admin-operations-core.js";
/** Content-free durable evidence; does not claim provider invoicing, current approval or shipping. */
export const adminBookProductionSchema = z
    .object({
    version: z.literal("ADMIN_BOOK_PRODUCTION_V1"),
    bookId: adminUlidSchema,
    observedAt: z.string().datetime(),
    readClass: z.literal("INDIVIDUALLY_CONSISTENT_NONATOMIC_READS"),
    source: z
        .object({
        present: z.boolean(),
        revision: z.number().int().nonnegative().nullable(),
        updatedAt: z.string().datetime().nullable(),
    })
        .strict(),
    project: z
        .object({
        revision: z.number().int().nonnegative().nullable(),
        pendingJobIds: z.array(adminUlidSchema).max(100),
    })
        .strict(),
    budget: z
        .object({
        present: z.boolean(),
        revision: z.number().int().nonnegative().nullable(),
        limitMicros: z.number().int().positive().nullable(),
        actualCostMicros: z.number().int().nonnegative().nullable(),
        reservedCostMicros: z.number().int().nonnegative().nullable(),
        remainingCostMicros: z.number().int().nonnegative().nullable(),
        unknownCostHoldMicros: z.number().int().nonnegative(),
        completeCostEvidence: z.boolean(),
        truthBoundary: z.literal("REPORTED_ESTIMATES_AND_RESERVATIONS_NOT_PROVIDER_INVOICE"),
    })
        .strict(),
    jobs: z
        .array(z
        .object({
        id: adminUlidSchema,
        task: adminSafeIdentifierSchema,
        state: adminSafeIdentifierSchema,
        updatedAt: z.string().datetime(),
        actualCostMicros: z.number().int().nonnegative().nullable(),
        costEvidenceSource: adminSafeIdentifierSchema,
        failureReason: adminSafeIdentifierSchema.nullable(),
        retiredWithUnknownHold: z.boolean(),
    })
        .strict())
        .max(100),
    print: z
        .object({
        planDigestSha256: adminSha256Schema.nullable(),
        editionPreviewId: adminSafeIdentifierSchema.nullable(),
        packageId: adminSafeIdentifierSchema.nullable(),
        packageState: adminSafeIdentifierSchema.nullable(),
        coverSha256: adminSha256Schema.nullable(),
        interiorSha256: adminSha256Schema.nullable(),
        profileId: adminSafeIdentifierSchema.nullable(),
        profileVersion: adminSafeIdentifierSchema.nullable(),
        validatorState: adminSafeIdentifierSchema.nullable(),
        printApprovalState: adminSafeIdentifierSchema.nullable(),
        readinessClaimed: z.literal(false),
        operations: z
            .array(z
            .object({
            operationId: adminSafeIdentifierSchema,
            state: adminSafeIdentifierSchema,
            updatedAt: z.string().datetime(),
            failureCode: adminSafeIdentifierSchema.nullable(),
        })
            .strict())
            .max(50),
    })
        .strict(),
    legacyRecoveryAvailable: z.boolean(),
    truncated: z.boolean(),
    providerDispatchAuthorized: z.literal(false),
})
    .strict();
//# sourceMappingURL=admin-book-production.js.map